import React from 'react';
import { FadeIn } from './ui/FadeIn';
const cases = ['Luxury Apartments', 'Corporate Housing', 'Serviced Apartments', 'Commercial Spaces', 'Expatriate Housing', 'Diaspora Property Search', 'Remote Investors', 'Shortlet Marketing'];
export function UseCases() {
  return <section className="py-24 bg-zinc-950 overflow-hidden" data-id="element-250">
      <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-251">
        <FadeIn data-id="element-252">
          <h2 className="text-sm font-medium tracking-widest uppercase text-zinc-500 mb-12" data-id="element-253">
            Ideal Use Cases
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto" data-id="element-254">
          {cases.map((item, index) => <div key={index} className="px-6 py-3 rounded-full glass-panel text-zinc-300 text-sm md:text-base hover:text-white hover:bg-white/10 transition-colors cursor-default" data-id="element-255">
              {item}
            </div>)}
        </FadeIn>
      </div>
    </section>;
}